import { AtsTicketAssets } from "../components/modules/asset/maps/queries/types";
import {
  AtsStckItem,
  AtsStckItemDetails,
  AtsTicketsForTicketDetailsByNodeData,
  AtsTicketsForTicketDetailsByNodeType,
  InputTicketDetails,
} from "../components/modules/asset/masters/items/queries/types";
import { AtsSubsidiary } from "../components/modules/asset/masters/subsidary/queries/types";
import { AtsAcLdgr } from "../components/modules/asset/masters/supplier/queries/types";
import {
  AtsCompany,
  TableType,
} from "../components/modules/customer/companies/queries/types";
import {
  OrderDirection,
  pageInfo,
  userDetails,
} from "../utils/commonQueryTypes";
import { TicketStatus } from "../utils/constants";
import { PriorityEnum } from "../utils/Enum.types";

export enum tableKey {
  MRFNO = "MRF",
  RFQNO = "RFQ",
  PO = "PO",
  TICKET = "TICKET",
}

export interface PredefinedDataByTypeListNode {
  id: number;
  index: number;
  type: string;
  value1: string;
  value2: string;
  value3: string;
  value4: string;
  edit: string;
}

export interface PredefinedDataByTypeEdge {
  node: PredefinedDataByTypeListNode;
  cursor: string;
  value: number;
}
export interface PredefinedDataByTypePageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string;
  endCursor: string;
}
export interface PredefinedDataByTypeList {
  totalCount: number;
  pageInfo: PredefinedDataByTypePageInfo;
  edges: PredefinedDataByTypeEdge[];
}
export interface PredefinedDataByTypeData {
  GetPredefinedDataByType: PredefinedDataByTypeList;
}

export interface PredefinedDataByTypevars {
  token?: string;
  type: string;
  Lname?: string;
  first?: number | null;
  after?: string | null;
  sortBy?: string;
  direction?: string;
}
export interface PredefinedDataTypeData {
  GetMstInstReferenceDataTypes: string[];
}

export interface PredefinedDataTypevars {
  token: string;
  inst_id: string | number;
}

export interface ServerDateTimeData {
  GetServerDateAndTime: string;
}

export interface ServerDateTimeWithoutTokenData {
  GetServerDateAndTimeWithoutToken: string;
}
export interface ServerDateTimeVars {
  token?: string;
}

export interface ServerDateTimeWithoutTokenVars {
  customer_id: number;
}

export interface GetSqlNumberVars {
  token?: string;
  customerID: number;
  companyID: number;
  tableKey: tableKey;
}

export interface GetSqlNumberResult {
  GetSqlNumber: {
    sqlNumber: string;
    tableKey: string;
  };
}

export interface EmpMaster {
  id: number;
  kgid: number;
  metalNo: number;
  name: string;
  type: string;
  customer: {
    name: string;
  };
  address: string;
  email: string;
  designation: string;
  mobile: string;
  pin: string;
  place: string;
  state: string;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
}

export interface AddTicketVars {
  token?: string;
  customerID: number;
  user_details: userDetails;
  input: InputTicketDetails;
  loggedBy?: number;
}

export interface AddTicketResult {
  AddTicket: {
    ticketNo: string
    ticketDetails: {
      id: number;
    }[];
  };
}

export interface TicketDetailsResult {
  itemDetailsID: number;
  anyChanges: string;
  AnySparesChanged: string;
  remarks: string;
  imagesPath: string;
}

export interface TicketDetails {
  ticketNo: string;
  ticketDate: string;
  reason: string;
  type: string;
  remarks: string;
  itemDetailsID: number;
  siteID: number;
  junctionID: number;
  imagesPath: string;
}
export interface AtsSubsidiarySite {
  name: string;
}

export interface AtsJunctions {
  id: number;
  name: string;
  code: string;
  jType: string;
  arms: number;
  icon: string;
  alias: string;
  vendorDetails: {
    desc: string;
  };
}
export interface TicketNode {
  id: number;
  ticketNo: string;
  ticketDate: string;
  reason: string;
  type: string;
  priority: string;
  status: string;
  remarks: string;
  logCompleteDate: string;
  logDuration: string;
  subsidiaryID: number;
  siteID: number;
  logVerifiedBy: string;
  loggedBy: string;
  item: AtsStckItem;
  itemDetails: AtsStckItemDetails;
  subsidiaryDetails: AtsSubsidiary;
  site: AtsSubsidiarySite;
  junction: AtsJunctions;
  tableLevel: TableType;
  ticketDetails: AtsTicketsForTicketDetailsByNodeData;
  poleNum: number;
  closedDate: string;
  loggedUser: EmpMaster;
  orderedDetails: AtsTicketsForTicketDetailsByNodeType[];
  lastRemarks: string;
  junctionID: number;
  company: AtsCompany;
  closedDuration: number;
  vendorDetails: AtsAcLdgr;
  ticketAssetDetails: AtsTicketAssets[];
  ticket_raised_by_name: string;
  ticket_raised_by_desgn: string;
  ticket_raised_by_phone_no: string;
}

export interface TicketEdge {
  node: TicketNode;
}

export interface TicketPageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string;
  endCursor: string;
}

export interface GetTicketsData {
  GetTickets: {
    edges: TicketEdge[];
    pageInfo: pageInfo;
    totalCount: number;
  };
}

export enum AtsTicketsOrderField {
  TICKET_NO = "TICKET_NO",
  CREATED_AT = "CREATED_AT",
}
export interface AtsTicketsOrder {
  direction: OrderDirection;
  field: AtsTicketsOrderField;
}

export enum TicketsQueryType {
  ALL = "ALL",
  SLA_REPORT = "SLA_REPORT",
}

export interface TicketQuery {
  query_type: TicketsQueryType;
  stckCategoryID: number;
  stckGroupID: number;
  stckManufacturerID: number;
  stckUomID: number;
  stckSubCategoryID: number;
  itemID: number;
  ldgrID: number;
  itemDetailsID: number;
  status: TicketStatus[];
  priority: PriorityEnum[];
  empID: number;
}

export interface GetTicketsVars {
  token?: string;
  after: string | null;
  first: number;
  customerID: number;
  companyID: number;
  subsidiaryID: number;
  junctionID: number;
  siteID: number;
  input: TicketQuery;
  orderBy: AtsTicketsOrder;
  name: string;
  reason: string;
  startDate?: string;
  endDate?: string;
}

export interface tableDetails {
  tableID: number;
  tableType: TableType;
}
export interface GetAssetCountsReportVariables extends tableDetails {
  customerID: number;
  itemID: number;
}
export interface AssetCounts {
  assetCount: number;
  workingCount: number;
  notWorkingCount: number;
  spanCount: number;
}

export interface SiteDetailsType {
  siteName: string;
  siteID: number;
  assetCount: number;
  workingCount: number;
  notWorkingCount: number;
}

export interface SubsidiaryDetailsType extends AssetCounts {
  subsidiaryName: string;
  subsidiaryID: number;
  siteDetails: SiteDetailsType[];
}

export interface CompanyDetailsType extends AssetCounts {
  companyName: string;
  companyID: string;
  subsidiaryDetails: SubsidiaryDetailsType[];
}

export interface GetAssetCountsReportResult {
  GetAssetCountsReport: CompanyDetailsType[];
}

export enum CustomerConfigurationTypes {
  ENABLE_MAPS = "ENABLE_MAPS",
  ENABLE_SUBSIDIARY = "ENABLE_SUBSIDIARY",
  ENABLE_SUBSIDIARY_SITE = "ENABLE_SUBSIDIARY_SITE",
  ENABLE_JUNCTION = "ENABLE_JUNCTION",
}

export enum AcdCustomerAllocationData {
  ENABLE_MAPS = "ENABLE_MAPS",
  ENABLE_SUBSIDIARY = "ENABLE_SUBSIDIARY",
  ENABLE_SUBSIDIARY_SITE = "ENABLE_SUBSIDIARY_SITE",
  ENABLE_JUNCTION = "ENABLE_JUNCTION",
  NONE = "NONE",
}

export interface ResetEmpPasswordInput {
  empID: number;
  customerID: number;
  user_details: userDetails;
  password: string;
}

export interface ResetEmpPasswordOutput {
  ResetEmpPassword: boolean;
}

export interface ExportTicketsJunctionWiseResult {
  ExportTicketsJunctionWise: string;
}

export interface ExportTicketsJunctionWiseVar {
  token?: string;
  customerID: number;
  startDate?: string;
  endDate?: string;
  ldgrID: number;
}